import { FC, useEffect, useState } from "react";
import { ReactComponent as RightIcon } from "assets/expand.svg";
import styles from "./Opportunities.module.scss";
import useExternalApiService from "helpers/ExternalApiService";
import { store } from "stores/Store";
import { useNavigate } from "react-router-dom";
import { Box, Collapse, Group, ScrollArea, Title } from "@mantine/core";
import { getShortDateUSStyle } from "helpers/date";
import { useDisclosure } from "@mantine/hooks";
import { ReactComponent as ExpandIcon } from "assets/expand.svg";
import { formatCurrency, formatMoney } from "helpers";

interface Props {

}

interface Opportunity {
  id: number;
  status: string;
  forecast_type: string;
  projected_total: number; 
  annual_estimate: number;
  expected_close_date: string;
  is_risk: boolean;
  products: {
    quantity: number;
    unit_price: number;
    name: string;
    id: number;
  }[];
};

const Opportunities: FC<Props> = () => {
  const navigate = useNavigate();
  const [opportunities, setOpportunities] = useState<Opportunity[]>([]);
  const [isOppVisible, { 
    toggle: toggleOppVisibility,
    open: setOppVisible,
  }] = useDisclosure(false)
  const [isRiskVisible, { 
    toggle: toggleRiskVisibility ,
    open: setRisksVisible,
  }] = useDisclosure(false)

  const apiUrl = process.env.REACT_APP_EAI_URL;
  const { getData } = useExternalApiService(apiUrl);

  // Grab the current practitioner’s netsuite_id
  const netsuiteId = store.currentPractitioner?.netsuite_id;
  const stage = store.currentPractitioner?.stage;
  const status = store.currentPractitioner?.status;


  const projection = opportunities.reduce((acc, cur) => {
    // if (cur?.products) { // This is wrong, don't ignore all opportunities with products.  Instead, check to see if projected_total exists.
    if (cur.projected_total == null || cur.projected_total == undefined) {
      return acc;
    }
    if (cur.is_risk) {
      return acc - (Math.trunc(cur.projected_total) || 0);
    } else {
      return acc + (Math.trunc(cur.projected_total) || 0);
    }
    
    // if (!cur.products) return acc;
    // return acc + cur.products.reduce((pAcc, pCur) => {
    //   return pAcc + (pCur.quantity || 0) * (pCur.unit_price || 0) * 0.01;
    // }, 0);
  }, 0);

  const currentFullYear = (new Date()).getFullYear();

  const opps =  opportunities.filter((o) => !o?.is_risk);
  const risks =  opportunities.filter((o) => o?.is_risk);

  useEffect(() => {
    // If there is no netsuiteId, don’t attempt to fetch opportunities at all.
    if (!netsuiteId) {
      return;
    }

    // Otherwise get the opportunities for this practitioner
    const practId = store?.currentPractitioner?.id;
    getData(`/api/${practId}/get_opportunities`).then(
      (r) => {
        setOpportunities(r.opportunities);

        if (r.opportunities?.find((o: any) => o.is_risk)) {
          setRisksVisible();
        }
        if (r.opportunities?.find((o: any) => !o.is_risk)) {
          setOppVisible();
        }
      }
    )
  }, [netsuiteId]);

  const hasAwaiting = opportunities.some(
    (cur) => cur.projected_total == null
  );

  // 5) Now that all hooks have been declared, do the conditional return:
  // 5b) Check if stage and status meet requirements
  const canTrackOpportunity = netsuiteId && (stage === "CUSTOMER" || stage === "PROSPECT");

  //if (!netsuiteId) {
  if (!canTrackOpportunity) {
    return (
      <div className={styles["opp-warning-container"]}>
        <p className={styles["opp-warning-text"]}>
          To track opportunities with this practitioner, we need them to be in Netsuite and has the status "PROSPECT" or "CUSTOMER".
        </p>
      </div>
    );
  }

  // 6) If we get here, netsuiteId is there, so we display the sales pipeline for the practitioner.

  console.log("projection=", projection);

  return (
    <div className={styles["opp-container"]}>
      <div className={styles["opp-header"]}>
        <Box mb={10} pt={10}>
          <h4 className={styles["opp-header__title"]}>
            {/*currentFullYear*/} {/*Annual Impact for Customer*/}
            Annual Revenue Forecast for Customer
          </h4>
          <Title order={5} fw="normal" mt={5}>
            Opportunities minus Risks
          </Title>
        </Box>
        <Box mt={5}>          
            {/*formatMoney(projection + "" || "0", true)*/}
            {hasAwaiting ? (              
              <h1 className={styles["opp-header__value-awaiting"]}>                
                  Awaiting <br /> Netsuite Data                              
              </h1>
            ) : (
              <h1 className={styles["opp-header__value"]} title="Awaiting Netsuite Calculation">
                {formatMoney(projection + "", true)}
              </h1>
            )}          
          <Title order={5} fw="normal" mt={-15} ta="center">
            By end of {currentFullYear}
          </Title>
        </Box>
        <div className={styles["opp-header__sub-header"]}>
          <Group
            onClick={() => toggleOppVisibility()}>
            <Title order={4}>
              Opportunities
            </Title>
            <ExpandIcon
              style={{
                width: '20px',
                height: '20px',
                transform: isOppVisible ? "rotate(270deg)" : "rotate(90deg)",
                transition: "transform 0.2s"
              }} />
          </Group>
          <button onClick={() => {
            navigate(`/?${new URLSearchParams({ showOpportunityForm: 'true' }).toString()}`)
          }}>
            ADD
          </button>
        </div>
      </div>
      <Collapse in={isOppVisible}>
        <ScrollArea mah={300} scrollbars="y" mb={-15} pb={0}>
          <ul className={styles["opp-list"]}>
            {opps.map((o, index) => (
              <li key={index} className={styles["opp-list__item"]} onClick={() => {
                navigate(`/?${new URLSearchParams({ showOpportunityForm: 'true', oppId: String(o.id) }).toString()}`)
              }}>
                <div className={styles["opp-list__item-index"]}>{index + 1}.</div>
                <div className={styles["opp-list__item-value"]}>
                  {/*!o.products || o.products?.filter((p) => p.quantity).length === 0 ? (
                  <h1 className={styles["opp-list__item-value--proj"]}>{((o.annual_estimate || 0)/1000).toFixed(2)}k</h1>
                ): (
                  <h5 className={styles["opp-list__item-awaiting"]}>
                    Awaiting Netsuite Data
                  </h5>
                )*/}
                  {/*<p>{new Date(o.expected_close_date).toLocaleDateString()}</p>*/}
                  {(
                    //!(o.products && o.products.filter((p) => p.quantity).length > 0)
                    o.projected_total !== null && o.projected_total !== undefined
                  ) ? (
                    <div className={styles["opp-list__item-norm-wrapper"]}>
                      <h1 className={styles["opp-list__item-value--proj"]}>
                        {/*((o.annual_estimate || 0) / 1000).toFixed(2)*/}{/*k*/}
                        {formatMoney((o.projected_total + "" || "0"), true)}
                      </h1>
                      <p className={styles["opp-list__item-date"]}>
                        By {getShortDateUSStyle(new Date(o.expected_close_date))}
                      </p>
                    </div>                    
                  ) : (
                    <div className={styles["opp-list__item-awaiting-wrapper"]}>
                      <div className={styles["opp-list__item-awaiting"]}>
                        Awaiting Netsuite Data
                      </div>
                      <p className={styles["opp-list__item-date"]}>
                        {/*new Date(o.expected_close_date).toLocaleDateString()*/}
                        By {getShortDateUSStyle(new Date(o.expected_close_date))}
                      </p>
                    </div>                    
                  )}
                </div>
                <div className={styles["opp-list__item-sub-list"]}>
                  <h5>{o.status}</h5>
                  <ol>
                    {(o?.products ?? []).slice(0, 3).map((p, i) => (
                      <li key={`o_${i}`}>{p?.name?.slice(0, 15)}: {p.quantity} units</li>
                    ))}
                  </ol>
                </div>
                <RightIcon className={styles["opp-list__item-action"]} />
              </li>
            ))}
          </ul>
        </ScrollArea>
      </Collapse>
      <div className={styles["opp-header__sub-header"]}>
        <Group>
          <Title order={4} c="#C20E0E">
            Risks
          </Title>
          <ExpandIcon
            onClick={() => toggleRiskVisibility()}
            style={{
              width: '20px',
              height: '20px',
              transform: isRiskVisible ? "rotate(270deg)" : "rotate(90deg)",
              transition: "transform 0.2s"
            }} />
        </Group>
        <button onClick={() => {
          navigate(`/?${new URLSearchParams({ showRiskForm: 'true' }).toString()}`)
        }}>
          ADD
        </button>
      </div>
      <Collapse in={isRiskVisible}>
        <ScrollArea mah={300} scrollbars="y" mb={-15} pb={0}>
          <ul className={styles["opp-list"]}>
            {risks.map((o, index) => (
              <li key={index} className={styles["opp-list__item"]} onClick={() => {
                navigate(`/?${new URLSearchParams({ showRiskForm: 'true', riskId: String(o.id) }).toString()}`)
              }}>
                <div className={styles["opp-list__item-index"]}>{index + 1}.</div>
                <div className={styles["opp-list__item-value"]}>
                  {/*!o.products || o.products?.filter((p) => p.quantity).length === 0 ? (
                  <h1 className={styles["opp-list__item-value--proj"]}>{((o.annual_estimate || 0)/1000).toFixed(2)}k</h1>
                ): (
                  <h5 className={styles["opp-list__item-awaiting"]}>
                    Awaiting Netsuite Data
                  </h5>
                )*/}
                  {/*<p>{new Date(o.expected_close_date).toLocaleDateString()}</p>*/}
                  {(
                    o.projected_total !== null && o.projected_total !== undefined
                  ) ? (                  
                    // 2. o.projected_total is not null: which means it's been filled by the backend table. 
                    <div className={styles["opp-list__item-norm-wrapper"]}>
                      <h1 
                        className={styles["opp-list__item-value--proj-risk"]}>
                        {/*((o.annual_estimate || 0) / 1000).toFixed(2)*/}{/*k*/}
                        -{formatMoney((o.projected_total + "" || "0"), true)}
                      </h1>
                      <p className={styles["opp-list__item-date"]}>
                        By {getShortDateUSStyle(new Date(o.expected_close_date))}
                      </p>
                    </div>
                  ) : (
                    <div className={styles["opp-list__item-awaiting-wrapper"]}>
                      <div className={styles["opp-list__item-awaiting"]}>
                        Awaiting Netsuite Data
                      </div>
                      <p className={styles["opp-list__item-date"]}>
                        {/*new Date(o.expected_close_date).toLocaleDateString()*/}
                        By {getShortDateUSStyle(new Date(o.expected_close_date))}
                      </p>
                    </div>
                  )}
                </div>
                <div className={styles["opp-list__item-sub-list"]}>
                  <h5>{o.status}</h5>
                  <ol>
                    {(o?.products ?? []).slice(0, 3).map((p, i) => (
                      <li key={`o_${i}`}>{p?.name?.slice(0, 15)}: {p.quantity} units</li>
                    ))}
                  </ol>
                </div>
                <RightIcon className={styles["opp-list__item-action"]} />
              </li>
            ))}
          </ul>
        </ScrollArea>
      </Collapse>
    </div>
  )
};

export default Opportunities;